<script lang="ts">
  // 2 · How you work: default rate, how durations look, theme, quick time input.
  import { Sun, Moon, Monitor } from '@lucide/svelte';
  import { t } from '../../i18n.svelte';
  import { prefs, type DurationFormat, type Theme } from '../../prefs.svelte';
  import { Field, MoneyInput, Segmented, Toggle } from '../../ui';
  import StepIntro from './StepIntro.svelte';
  import { flow } from '../state.svelte';

  const durationOptions = $derived<Array<{ value: DurationFormat; label: string }>>([
    { value: 'hm', label: t('onb.work.duration_hm') },
    { value: 'decimal', label: t('onb.work.duration_decimal') },
    { value: 'text', label: t('onb.work.duration_text') }
  ]);
  const themeOptions = $derived<Array<{ value: Theme; label: string; icon: typeof Sun }>>([
    { value: 'light', label: t('onb.work.theme_light'), icon: Sun },
    { value: 'dark', label: t('onb.work.theme_dark'), icon: Moon },
    { value: 'system', label: t('onb.work.theme_system'), icon: Monitor }
  ]);
</script>

<StepIntro kicker={t('onb.work.kicker')} title={t('onb.work.title')} lead={t('onb.work.text')} />
<div class="stack">
  <Field label={t('onb.work.rate')} for="onb-rate" error={flow.rateError} hint={t('onb.work.rate_hint')}>
    <div class="rate">
      <MoneyInput id="onb-rate" bind:value={flow.rate} placeholder="75,00" suffix={t('common.per_hour')} onchange={() => (flow.rateError = null)} />
    </div>
  </Field>
  <Field label={t('onb.work.duration')}>
    <Segmented value={prefs.value.durationFormat} options={durationOptions} full ariaLabel={t('onb.work.duration')} onchange={(v) => prefs.update({ durationFormat: v })} />
  </Field>
  <Field label={t('onb.work.theme')}>
    <Segmented value={prefs.value.theme} options={themeOptions} full ariaLabel={t('onb.work.theme')} onchange={(v) => prefs.update({ theme: v })} />
  </Field>
  <Toggle bind:checked={flow.quick} label={t('onb.work.quick')} description={t('onb.work.quick_text')} />
</div>

<style>
  .rate { max-width: 240px; }
  @media (max-width: 720px) {
    .rate { max-width: none; }
  }
</style>
